/** Static motion values shared by web styles and native animation hooks. */
export const Motion = {
  duration: {
    flash: 80,
    fast: 150,
    normal: 300,
    slow: 500,
    entrance: 800,
    cinema: 1200,
  },
  easing: {
    easeOutExpo: [0.16, 1, 0.3, 1] as const,
    easeInOutCubic: [0.65, 0, 0.35, 1] as const,
    easeOutBack: [0.34, 1.56, 0.64, 1] as const,
    easeInExpo: [0.7, 0, 0.84, 0] as const,
  },
  // Quiet, settled return: close to critical damping for this stiffness.
  spring: { stiffness: 420, damping: 40, mass: 1 },
};
